export function graphiteUserHeader(userKey: string) {
  return encodeURIComponent(userKey);
}
